import React, { useState, useEffect } from 'react';
import { Spin, Alert, notification } from 'antd';
import { getStartPage, saveStartPage } from '../util/APIUtils'; 
import AdminPageEditor from './AdminPageEditor';

const StartPage = (props) => {
    const [initialContent, setInitialContent] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const [loading, setLoading] = useState(true); 
    const [error, setError] = useState(null);

    useEffect(() => {
        const getContent = async () => {
            try {
                const response = await getStartPage();
                if (response && response.content) {
                    setInitialContent(response.content);
                }
            } catch (err) {
                console.error(err);
                setError('Failed to load page content.');
                notification.error({
                    message: 'Loading Error',
                    description: err.message || 'Could not fetch initial content.',
                });
            } finally {
                setLoading(false); 
            }
        };

        getContent();
    }, []); 

    const handleSaveContent = (content) => {
        setIsSaving(true);
        setError(null);

        const payload = { content };

        saveStartPage(payload)
            .then(response => {
                notification.success({
                    message: 'Success!',
                    description: 'The start page has been saved successfully.',
                });
            })
            .catch(e => {
                setError('Failed to save page content.');
                notification.error({
                    message: 'Save Error',
                    description: e.message || 'Could not save the start page content.',
                });
            })
            .finally(() => {
                setIsSaving(false);
            });
    };

    if (loading) {
        return <Spin size="large" tip="Loading Editor..." style={{ display: 'block', marginTop: '20px' }} />;
    }

    if (error) {
        return <Alert message="Error" description={error} type="error" showIcon />;
    }

    return (
        <div>
            <AdminPageEditor
                initialValue={initialContent}
                onSave={handleSaveContent}
                isSaving={isSaving}
            />
        </div>
    );
};

export default StartPage;